import {
  IExpressionBehaviorSpecifiable, instanceOfIExpressionBehaviorSpecifiable,
  INumberStyleSpecifiable, instanceOfINumberStyleSpecifiable,
  INumberRangeAlertBehaviorSpecifiable, instanceOfINumberRangeAlertBehaviorSpecifiable,
  IDecimalRoundBehaviorSpecifiable, instanceOfIDecimalRoundBehaviorSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { ICalculatableObject, instanceOfICalculatableObject } from "./ICalculatableObject";

export interface ICalculateObject extends
ICalculatableObject,
IExpressionBehaviorSpecifiable,
INumberStyleSpecifiable,
INumberRangeAlertBehaviorSpecifiable,
IDecimalRoundBehaviorSpecifiable {
  // TODO: 独自要素の実装.
}

export function instanceOfICalculateObject(instance: any): instance is ICalculateObject {
  return instance
      && instanceOfIExpressionBehaviorSpecifiable(instance)
      && instanceOfINumberStyleSpecifiable(instance)
      && instanceOfINumberRangeAlertBehaviorSpecifiable(instance)
      && instanceOfIDecimalRoundBehaviorSpecifiable(instance)
      && instanceOfICalculatableObject<ICalculateObject>(instance, "calculate");
}
